import { render, staticRenderFns } from "./DevolucaoPages.vue?vue&type=template&id=2614b76a&"
import script from "./DevolucaoPages.vue?vue&type=script&lang=js&"
export * from "./DevolucaoPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports